import qs from 'qs';

export default function queryParams(search = window.location.search) {
  return qs.parse(search, { ignoreQueryPrefix: true });
}
